/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAnalytics = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M22 9V2h-7v2h3.6L14 8.6l-4-4-6 6V2H2v20h20v-2h-2v-9h-2v9h-2v-5h-2v5h-2v-8h-2v8H8v-6H6v6H4v-6.6l6-6 4 4 6-6V9z"
    />
  </Icon>
);
export { SvgAnalytics as Analytics };
